import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router'
import { COURSES } from '../data'
import { useGame } from '../GameContext'
import { Button, WashiTape } from '../components/ui'
import { ArrowRight, QrCode } from 'lucide-react'

let hasBooted = false

export default function CourseSelect() {
  const navigate = useNavigate()
  const { gameState } = useGame()
  const [flashRedirect] = useState(() => {
    const first = !hasBooted
    hasBooted = true
    return first
  })

  const target = (() => {
    const { course, players, holes } = gameState
    if (!course) return null
    if (players.length === 0) return '/setup'
    if (!holes.some((h) => h.scores.length > 0)) return '/rules'
    const playedHoles = holes.filter((h) => h.scores.length > 0).length
    if (playedHoles >= course.holes) return '/summary'
    return '/play'
  })()

  if (flashRedirect && target) return <Navigate to={target} replace />

  const totalPar = (c) =>
    c.holesData.reduce((sum, h) => sum + (h.par ?? 3), 0) || c.holes * 3

  return (
    <div className="min-h-screen flex flex-col py-6">
      <div className="flex-1 max-w-md w-full mx-auto space-y-6">
        <div className="text-center space-y-2 relative">
          <WashiTape className="left-1/2 -translate-x-1/2 -top-3" rotation="-3deg" />
          <h1 className="text-4xl font-hand relative z-10">Kies een baan</h1>
          <p className="text-muted-foreground mb-2">Selecteer de baan waar je speelt</p>
        </div>

        <div className="space-y-4">
          {COURSES.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => navigate(`/course/${c.id}`)}
              className="w-full text-left rounded-xl p-4 transition border-2 border-transparent hover:border-border focus:outline-none focus:ring-2 focus:ring-primary/30 bg-card shadow-paper hover:shadow-md"
            >
              <div className="flex items-center gap-4">
                <div
                  className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0"
                  style={{ backgroundColor: c.color }}
                >
                  <img src={c.logo} alt={c.name} className="w-full h-full object-contain" />
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="font-semibold truncate">{c.name}</h2>
                  <p className="text-sm text-muted-foreground line-clamp-2">{c.description}</p>
                  <div className="flex gap-4 mt-1 text-sm text-muted-foreground">
                    <span>{c.holes} holes</span>
                    <span>Par {totalPar(c)}</span>
                  </div>
                </div>
                <ArrowRight className="h-5 w-5 text-muted-foreground flex-shrink-0" />
              </div>
            </button>
          ))}
        </div>

        <div className="space-y-3 pt-2">
          <Button onClick={() => navigate('/scan')} variant="outline" className="w-full">
            <QrCode className="mr-2 h-4 w-4" />
            Baan scannen
          </Button>
        </div>
      </div>
    </div>
  )
}